var exports = {
  "k": "x7be19a29--bc6cc4--container",
};

module.exports = exports;
